import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import ListWithFilters from "../../CustomerPage/TabContent/ListWithFilters";
import { createNewAppeal } from "modules/appeal/actions";
import permissions, { checkPermissions } from "config/permissions";
import { openExportWizardModal } from "reducers/exportWizard";

const mapStateToProps = (state) => {
    return {
        tabs: state.tabs,
        canCreateAppeal: checkPermissions(permissions.AppealOperations.action_createAppeal),
        isExportAllowed: checkPermissions(permissions.SearchOperations.search_export),
    };
};


const mapDispatchToProps = {
    createNewAppeal,
    openExportWizardModal
}


function AppealsTabContent(props) {
    const {
        t,
        customerId,
        history,
        match: {
            url,
            params: { serviceId, appealId, orderId, resourceId, id: contactPersonId },
        },
        createNewAppeal,
        canCreateAppeal,
        isExportAllowed,
        openExportWizardModal,
    } = props;

    const itemId = serviceId || appealId || orderId || resourceId || contactPersonId;
    const path = url.split("/");
    const itemIdIndex = path.findIndex(item => +item === +itemId);
    const itemType = itemIdIndex ? path[itemIdIndex - 1] : "";

    const onCreateNewAppeal = async () => {
        const appealRequestData = {
            customerId,
            contactPersonId: parseInt(contactPersonId, 10) ,
        };
        try {
            const createdAppeal = await createNewAppeal({ appealRequestData });
            if (createdAppeal) {
                history.push(`/appeals/${createdAppeal.id}/`);
            }
        } catch (e) {
            console.error("PersonPage::onCreateNewAppel: Error ", e);
        }
    }

    function onExport() {
        openExportWizardModal({ luceneCode: "INTERACTION_REQUEST" })
    }

    return (
        <div className="contentWrapper without-top-border">
            <div className="customer-ordering-grid">
                {/* {customerId && (
                    <ContactPersonAppealList
                        selectItem={item => history.push(`/appeals/${item.id}`)}
                        customerId={customerId}
                    />
                )} */}
                {customerId && contactPersonId && (
                    <ListWithFilters
                        gridUrlKey="cp_grid_with_filters"
                        selectItem={item => history.push(`/appeals/${item.id}`)}
                        customerId={customerId}
                        itemId={itemId}
                        itemType={itemType}
                        code="appeals"
                        gridType="appeal"
                        gridCustomCode="INTERACTION_REQUEST"
                        gridCustomType="PERSON_INTERACTION_REQUEST"
                        gridConfigKey="appeal"
                        contactPersonId={contactPersonId}
                        // onGridExport={(grid) => onGridExport({t, customerId, contactPersonId, grid})}
                        onGridExport={isExportAllowed && onExport}
                        onGridFloatingButtonClick={canCreateAppeal && { asyncHandler: onCreateNewAppeal }}
                        shouldIncludeCustomersId
                        key={itemId ? `${customerId}_${contactPersonId}_${itemId}_${itemType}` : `${customerId}_${contactPersonId}_${itemType}`}
                    />
                )}
            </div>
        </div>
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppealsTabContent));

AppealsTabContent.propTypes = {
    data: PropTypes.object,
    match: PropTypes.object,
    user: PropTypes.object,
};
